/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDentalTooths } from 'app/entities/dental-tooth/dental-tooth.reducer';
import { getEntities as getDentalSurfaces } from 'app/entities/dental-surface/dental-surface.reducer';
import { createEntity, getEntity, reset, updateEntity } from './dental-tooth-surface.reducer';

export const DentalToothSurfaceUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const dentalTooths = useAppSelector(state => state.dentalTooth.entities);
  const dentalSurfaces = useAppSelector(state => state.dentalSurface.entities);
  const dentalToothSurfaceEntity = useAppSelector(state => state.dentalToothSurface.entity);
  const loading = useAppSelector(state => state.dentalToothSurface.loading);
  const updating = useAppSelector(state => state.dentalToothSurface.updating);
  const updateSuccess = useAppSelector(state => state.dentalToothSurface.updateSuccess);

  const handleClose = () => {
    navigate(`/dental-tooth-surface${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDentalTooths({}));
    dispatch(getDentalSurfaces({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...dentalToothSurfaceEntity,
      ...values,
      tooth: dentalTooths.find(it => it.id.toString() === values.tooth?.toString()),
      surface: dentalSurfaces.find(it => it.id.toString() === values.surface?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...dentalToothSurfaceEntity,
          tooth: dentalToothSurfaceEntity?.tooth?.id,
          surface: dentalToothSurfaceEntity?.surface?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.dentalToothSurface.home.createOrEditLabel" data-cy="DentalToothSurfaceCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.dentalToothSurface.home.createOrEditLabel">
              Create or edit a DentalToothSurface
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="dental-tooth-surface-id"
                  label={translate('tinyMedicRestApp.dentalToothSurface.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalToothSurface.active')}
                id="dental-tooth-surface-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalToothSurface.cursor')}
                id="dental-tooth-surface-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalToothSurface.lastupdated')}
                id="dental-tooth-surface-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalToothSurface.microSec')}
                id="dental-tooth-surface-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalToothSurface.timestampentry')}
                id="dental-tooth-surface-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                id="dental-tooth-surface-tooth"
                name="tooth"
                data-cy="tooth"
                label={translate('tinyMedicRestApp.dentalToothSurface.tooth')}
                type="select"
                required
              >
                <option value="" key="0" />
                {dentalTooths
                  ? dentalTooths.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="dental-tooth-surface-surface"
                name="surface"
                data-cy="surface"
                label={translate('tinyMedicRestApp.dentalToothSurface.surface')}
                type="select"
                required
              >
                <option value="" key="0" />
                {dentalSurfaces
                  ? dentalSurfaces.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/dental-tooth-surface" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DentalToothSurfaceUpdate;
